import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  HOMI_SETTINGS_FEATURE_KEY,
  HomiSettingsState,
} from './homi-settings.reducer';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';
import {
  EloDisplayValue,
  EloSettings,
  HomiSettings,
} from '@lyceo/shared/homi-settings/util-models';

export const selectHomiSettingsState = createFeatureSelector<HomiSettingsState>(
  HOMI_SETTINGS_FEATURE_KEY,
);

export const selectSettings = createSelector(
  selectHomiSettingsState,
  (state: HomiSettingsState) => state.settings,
);

export const selectPupilId = createSelector(
  selectSettings,
  (settings: HomiSettings | undefined) => settings?.personId,
);

export const selectEloSettings = createSelector(
  selectSettings,
  (settings: HomiSettings | undefined) => settings?.elo,
);

export const selectEloSettingsUri = createSelector(
  selectEloSettings,
  (eloSettings: EloSettings | undefined) => eloSettings?.linkUri,
);

export const selectRefreshCallState = createSelector(
  selectHomiSettingsState,
  (state: HomiSettingsState) => state.refreshCallState,
);

export const selectRefreshSettingsLoading = createSelector(
  selectRefreshCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);

export const selectSyncCallState = createSelector(
  selectHomiSettingsState,
  (state: HomiSettingsState) => state.syncCallState,
);

export const selectSyncLoading = createSelector(
  selectSyncCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);

export const selectEloDisplayValue = createSelector(
  selectEloSettings,
  (eloSettings) => (eloSettings ? EloDisplayValue[eloSettings.elo] : undefined),
);

export const selectSettingsPlanning = createSelector(
  selectSettings,
  (settings) => settings?.planning,
);

export const selectPlanningIndependent = createSelector(
  selectSettingsPlanning,
  (planning) => planning?.independent ?? true,
);

export const selectPlanningShowReflection = createSelector(
  selectSettingsPlanning,
  (planning) => planning?.showReflection ?? true,
);

export const selectPlanningShowTime = createSelector(
  selectSettingsPlanning,
  (planning) => planning?.showTime ?? true,
);
